<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <h1>Curriculums</h1>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-end">
      <v-col class="shrink">
        <router-link :to="{ name: 'Calendar' }">
          <v-btn rounded text>
            <v-icon left>mdi-calendar</v-icon>
            Calendar View
          </v-btn>
        </router-link>
      </v-col>
      <v-col class="shrink">
        <CurriculumForm
          title="Create Curriculum"
          method="create"
          buttonColor="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CurriculumList />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CurriculumForm from '@/components/curriculum/Form'
import CurriculumList from '@/components/curriculum/List'

export default {
  name: 'Home',
  components: {
    CurriculumForm,
    CurriculumList
  }
}
</script>
